<template>
  <div class="page">
    <div class="page__bd">

      <div class="weui-cells__group weui-cells__group_form">
        <div class="weui-cells">
          <div class="weui-cell weui-cell_active weui-cell_select">
            <div class="weui-cell__bd">
              <select class="weui-select" v-model="selected">
                <option :value="'main'">主信息</option>
                <option :value="0">库存明细</option>
                <option :value="1">请购单</option>
                <option :value="2">采购在途</option>
                <option :value="3">工单在途</option>
                <option :value="4">备货单</option>
                <option :value="5">销售订单</option>
                <option :value="6">工单需求</option>
                <option :value="7">出入库记录</option>
                <option :value="8">物料清单展开</option>
                <option :value="9">物料清单反查</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div v-show="selected == 'main'">
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-if="form.list">
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">物料名称</label>
              <span class="weui-form-preview__value">{{form.list[0].pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">物料编号</label>
              <span class="weui-form-preview__value">{{form.list[0].pr_code}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="form.list[0].pr_orispeccode">
              <label class="weui-form-preview__label">型号</label>
              <span class="weui-form-preview__value">{{form.list[0].pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="form.list[0].pr_spec">
              <label class="weui-form-preview__label">规格</label>
              <span class="weui-form-preview__value">{{form.list[0].pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单位</label>
              <span class="weui-form-preview__value">{{form.list[0].pr_unit}}</span>
            </div>
          </div>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview">
            <div class="form-detail-preview_num">1</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label"><b>总需求量(+)</b></label>
              <span class="weui-form-preview__value"><b>
                {{mainData.noShipment + mainData.noPicking + mainData.safeInventory + mainData.safeForecastUnClash}}
              </b></span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">订单未发货</label>
              <span class="weui-form-preview__value">{{mainData.noShipment}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">工单未领料</label>
              <span class="weui-form-preview__value">{{mainData.noPicking}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">安全库存</label>
              <span class="weui-form-preview__value">{{mainData.safeInventory}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">备货未核销</label>
              <span class="weui-form-preview__value">{{mainData.safeForecastUnClash}}</span>
            </div>
          </div>
          <div class="weui-form-preview__bd form-detail-preview">
            <div class="form-detail-preview_num">2</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label"><b>现有库存量(-)</b></label>
              <span class="weui-form-preview__value"><b>{{mainData.greattotal}}</b></span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">良品库存</label>
              <span class="weui-form-preview__value">{{mainData.greattotal}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">不良品库存</label>
              <span class="weui-form-preview__value">{{mainData.badtotal}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">总库存</label>
              <span class="weui-form-preview__value">{{mainData.greattotal + mainData.badtotal}}</span>
            </div>
          </div>
          <div class="weui-form-preview__bd form-detail-preview">
            <div class="form-detail-preview_num">3</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label"><b>在途库存量(-)</b></label>
              <span class="weui-form-preview__value"><b>
                {{mainData.purchase + mainData.noComplete + mainData.application}}
              </b></span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">采购未交</label>
              <span class="weui-form-preview__value">{{mainData.purchase}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">工单未完工</label>
              <span class="weui-form-preview__value">{{mainData.noComplete}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">请购未转</label>
              <span class="weui-form-preview__value">{{mainData.application}}</span>
            </div>
          </div>
          <div class="weui-form-preview__bd form-detail-preview">
            <div class="form-detail-preview_num">4</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label"><b>净需求</b></label>
              <span class="weui-form-preview__value"><b>
                {{
                  mainData.noShipment + mainData.noPicking + mainData.safeInventory + mainData.safeForecastUnClash + mainData.application
                  - mainData.greattotal - mainData.purchase - mainData.noComplete
                }}
              </b></span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 0">
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.pw_whcode">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">仓库编号</label>
              <span class="weui-form-preview__value">{{item.pw_whcode}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">仓库名称</label>
              <span class="weui-form-preview__value">{{item.wh_description}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">仓库类型</label>
              <span class="weui-form-preview__value">{{item.wh_type}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">库存数量</label>
              <span class="weui-form-preview__value">{{item.pw_onhand}}</span>
            </div>
          </div>
        </div> 
      </div>
      <div v-show="selected == 1">
        <div class="selector">
          <span>
            <input type="radio" name="radio_1" id="radio_1_1" v-model="radio_1" :value="true">
            <label for="radio_1_1"> {{'所有请购'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_1" id="radio_1_2" v-model="radio_1" :value="false">
            <label for="radio_1_2"> {{'未转采购单'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div
            class="weui-form-preview__bd form-detail-preview"
            v-for="(item, index) in listData"
            :key="item.id"
            v-show="radio_1 || (item.thisqty > 0 && item.ap_status == '已审核' && item.ad_status != '已关闭')"
          >
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">请购单号</label>
              <span class="weui-form-preview__value">{{item.ap_code}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">序号</label>
              <span class="weui-form-preview__value">{{item.ad_detno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">请购数量</label>
              <span class="weui-form-preview__value">{{item.ad_qty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">已转采购数</label>
              <span class="weui-form-preview__value">{{item.ad_yqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">需求日期</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.ad_delivery}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.ap_status}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 2">
        <div class="selector">
          <span>
            <input type="radio" name="radio_2" id="radio_2_1" v-model="radio_2" :value="true">
            <label for="radio_2_1"> {{'所有订单'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_2" id="radio_2_2" v-model="radio_2" :value="false">
            <label for="radio_2_2"> {{'未完成订单'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id" v-show="radio_2 || (item.thisqty > 0)">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">采购单号</label>
              <span class="weui-form-preview__value">{{item.pu_code}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">供应商</label>
              <span class="weui-form-preview__value">{{item.pu_vendname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">在途数量</label>
              <span class="weui-form-preview__value">{{item.thisqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">订单数量</label>
              <span class="weui-form-preview__value">{{item.pd_qty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">已交货数量</label>
              <span class="weui-form-preview__value">{{item.pd_acceptqty || 0}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">序号</label>
              <span class="weui-form-preview__value">{{item.pd_detno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.pu_status}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 3">
        <div class="selector">
          <span>
            <input type="radio" name="radio_3" id="radio_3_1" v-model="radio_3" :value="true">
            <label for="radio_3_1"> {{'所有工单'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_3" id="radio_3_2" v-model="radio_3" :value="false">
            <label for="radio_3_2"> {{'未完成工单'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id" v-show="radio_3 || (item.thisqty > 0)">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据编号</label>
              <span class="weui-form-preview__value">{{item.ma_code}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据类型</label>
              <span class="weui-form-preview__value">{{ getItemType(3, item.ma_tasktype) }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">外协厂商</label>
              <span class="weui-form-preview__value">{{item.ma_vendname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">在途数量</label>
              <span class="weui-form-preview__value">{{item.thisqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">工单数量</label>
              <span class="weui-form-preview__value">{{item.ma_qty || 0}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">已完工数</label>
              <span class="weui-form-preview__value">{{item.ma_madeqty || 0}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.ma_status}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 4">
        <div class="selector">
          <span>
            <input type="radio" name="radio_4" id="radio_4_1" v-model="radio_4" :value="true">
            <label for="radio_4_1"> {{'所有备货'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_4" id="radio_4_2" v-model="radio_4" :value="false">
            <label for="radio_4_2"> {{'未核销备货'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id" v-show="radio_4 || (item.thisqty > 0)">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">备货单号</label>
              <span class="weui-form-preview__value">{{item.sf_code}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">客户名称</label>
              <span class="weui-form-preview__value">{{item.sf_custname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">未核销数量</label>
              <span class="weui-form-preview__value">{{item.sd_qty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">备货数量</label>
              <span class="weui-form-preview__value">{{item.thisqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">已核销数量</label>
              <span class="weui-form-preview__value">{{item.sd_yqty || 0}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">交货日期</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.sd_delivery}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">序号</label>
              <span class="weui-form-preview__value">{{item.sd_detno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.sf_status}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 5">
        <div class="selector">
          <span>
            <input type="radio" name="radio_5" id="radio_5_1" v-model="radio_5" :value="true">
            <label for="radio_5_1"> {{'所有订单'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_5" id="radio_5_2" v-model="radio_5" :value="false">
            <label for="radio_5_2"> {{'未完成订单'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id" v-show="radio_5 || (item.thisqty > 0)">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">销售单号</label>
              <span class="weui-form-preview__value">{{item.sa_code}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">客户名称</label>
              <span class="weui-form-preview__value">{{item.sa_custname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">未交数量</label>
              <span class="weui-form-preview__value">{{item.thisqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">订单数量</label>
              <span class="weui-form-preview__value">{{item.sd_qty || 0}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">已出货数量</label>
              <span class="weui-form-preview__value">{{item.sd_sendqty || 0}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">交货日期</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.sd_delivery}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">序号</label>
              <span class="weui-form-preview__value">{{item.sd_detno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.sa_status}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 6">
        <div class="selector">
          <span>
            <input type="radio" name="radio_6" id="radio_6_1" v-model="radio_6" :value="true">
            <label for="radio_6_1"> {{'所有工单'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_6" id="radio_6_2" v-model="radio_6" :value="false">
            <label for="radio_6_2"> {{'未发料工单'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id" v-show="radio_6 || (item.unpickqty > 0)">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据编号</label>
              <span class="weui-form-preview__value">{{item.macode}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据类型</label>
              <span class="weui-form-preview__value">{{ getItemType(6, item.maketype) }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">外协厂商</label>
              <span class="weui-form-preview__value">{{item.vendname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">未发料数</label>
              <span class="weui-form-preview__value">{{item.unpickqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">需求数</label>
              <span class="weui-form-preview__value">{{item.mmqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">已领数</label>
              <span class="weui-form-preview__value">{{item.mmturngetqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">工单序号</label>
              <span class="weui-form-preview__value">{{item.mmdetno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.mastatus}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 7">
        <div class="selector">
          <span>
            <input type="radio" name="radio_7" id="radio_7_1" v-model="radio_7" :value="true">
            <label for="radio_7_1"> {{'所有单据'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_7" id="radio_7_2" v-model="radio_7" :value="false">
            <label for="radio_7_2"> {{'未审核单据'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id" v-show="radio_7 || item.pistatus == '未审核'">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据编号</label>
              <span class="weui-form-preview__value">{{item.piinoutno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据类型</label>
              <span class="weui-form-preview__value">{{ getItemType(7, item.piclass) }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">入库数量</label>
              <span class="weui-form-preview__value">{{item.inqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">出库数量</label>
              <span class="weui-form-preview__value">{{item.outqty}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">序号</label>
              <span class="weui-form-preview__value">{{item.pddetno}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单据状态</label>
              <span class="weui-form-preview__value">{{item.pistatus}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">日期</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.pi_date}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 8">
        <div class="selector">
          <span>
            <input type="radio" name="radio_8" id="radio_8_1" v-model="radio_8" :value="true">
            <label for="radio_8_1"> {{'多级展开'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_8" id="radio_8_2" v-model="radio_8" :value="false">
            <label for="radio_8_2"> {{'单级展开'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id">
            <div class="form-detail-preview_num">{{ index + 1 }}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label"><b>层级</b></label>
              <span class="weui-form-preview__value"><b>{{ item.bs_level }}</b></span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">物料编号</label>
              <span class="weui-form-preview__value">{{ item.bs_soncode }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">物料名称</label>
              <span class="weui-form-preview__value">{{ item.son_proddetail }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">物料规格</label>
              <span class="weui-form-preview__value">{{ item.son_prodspec }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单位</label>
              <span class="weui-form-preview__value">{{ item.son_produnit }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单位用量</label>
              <span class="weui-form-preview__value">{{ item.bs_baseqty }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">综合损耗%</label>
              <span class="weui-form-preview__value">{{ item.bs_lossrate }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">整体损耗%</label>
              <span class="weui-form-preview__value">{{ item.bs_bolossrate }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">明细损耗%</label>
              <span class="weui-form-preview__value">{{ item.bs_bdlossrate }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">工序</label>
              <span class="weui-form-preview__value">{{  }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">BOM序号</label>
              <span class="weui-form-preview__value">{{ item.bs_bddetno }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">位号</label>
              <span class="weui-form-preview__value">{{ item.bs_location }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">工作中心</label>
              <span class="weui-form-preview__value">{{ item.bs_wcname }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">备注</label>
              <span class="weui-form-preview__value">{{ item.bs_remark }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">型号</label>
              <span class="weui-form-preview__value">{{ item.son_prodorispec }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">厂家/品牌</label>
              <span class="weui-form-preview__value">{{ item.son_prodbrand }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 9">
        <div class="selector">
          <span>
            <input type="radio" name="radio_9" id="radio_9_1" v-model="radio_9" :value="true">
            <label for="radio_9_1"> {{'多级反查'}}</label>
          </span>
          <span>
            <input type="radio" name="radio_9" id="radio_9_2" v-model="radio_9" :value="false">
            <label for="radio_9_2"> {{'单级反查'}}</label>
          </span>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in listData" :key="item.id">
            <div class="form-detail-preview_num">{{index + 1}}</div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">反查料号</label>
              <span class="weui-form-preview__value">{{ item.bm_prcode }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">母件编号</label>
              <span class="weui-form-preview__value">{{ item.bm_mothercode }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">母件名称</label>
              <span class="weui-form-preview__value">{{ item.mo_proddetail }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">母件规格</label>
              <span class="weui-form-preview__value">{{ item.mo_prodspec }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">单位用量</label>
              <span class="weui-form-preview__value">{{ item.bm_baseqty }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">备注</label>
              <span class="weui-form-preview__value">{{ item.bm_remark }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">反查层级</label>
              <span class="weui-form-preview__value">{{ item.bm_level }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">是否顶层</label>
              <span class="weui-form-preview__value">{{ item.bm_iftop ? "是" : "否" }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">类型</label>
              <span class="weui-form-preview__value">{{ item.bm_type }}</span>
            </div>
          </div>
        </div>        
      </div>

    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/document/product/list",
      mainDataUrl: "/api/make/bomComposite/searchMainData/",
      urlList: [
        "/api/make/bomComposite/stockDetailList/",
        "/api/make/bomComposite/applicationList/",
        "/api/make/bomComposite/purcList/",
        "/api/make/bomComposite/makeList/",
        "/api/make/bomComposite/saleforecastList/",
        "/api/make/bomComposite/saleList/",
        "/api/make/bomComposite/workOrderNeedList/",
        "/api/make/bomComposite/putWarehouseList/",
        [
          "/api/make/bom/bomStruct/",
          "/api/make/bom/bomStructOne/",
        ],
        [
          "/api/make/bom/bomMutiBack/",
          "/api/make/bom/bomMutiBackOne/",
        ],
      ],
      radio_1: false,
      radio_2: false,
      radio_3: false,
      radio_4: false,
      radio_5: false,
      radio_6: false,
      radio_7: false,
      radio_8: true,
      radio_9: true,
      mainData: {
        application: 0,
        badtotal: 0,
        greattotal: 0,
        noComplete: 0,
        noPicking: 0,
        noShipment: 0,
        purchase: 0,
        safeForecastUnClash: 0,
        safeInventory: 0,
      },
      listData: [],
      selected: 'main',
      itemType: {
        3: {
          MAKE: "制造工单",
          OS: "外协工单"
        },
        6: {
          MAKE: "制造工单",
          OS: "外协工单"
        },
        7: {
          PURCIN: "采购入库",
          PURCOUT: "采购退货",
          SALEOUT: "销售出货",
          SALERETURN: "销售退货",
          OTHERIN: "其它入库",
          OTHEROUT: "其它出库",
          MOVEOUT: "移仓单",
          MAKEPICK: "生产领料",
          OSMAKEPICK: "外协领料",
          MAKEIN: "完工入库",
          OSMAKEIN: "外协验收",
          OSMAKEINBACK: "外协验退",
          MAKE: "生产退料",
          OSMAKE: "外协退料",
          RESERVEINITIALIZE: "库存初始化",
          GOODSSEND: "发出商品初始化",
          ESTIMATE: "暂估初始化",
        },
      }
    };
  },
  methods: {
    /*
      重写，$loading的url和params
    */
    f_get(callback, id) {
      var me = this;
      id = id || me.initId || me.$route.params.id || me.$route.query.id;
      if (id) {
          me.$loading({
              url: me.baseUrl,
              params: {
                condition: JSON.stringify([{"type":"condition","value":"(pr_code like '%" + id + "%' or pr_detail like '%" + id + "%' or pr_orispeccode like '%" + id + "%' or pr_spec like '%" + id + "%')"}])
              }
          }).then(function (res) {
              if (res.success) {
                  me.form = res.data;
                  if (callback && typeof callback === 'function') {
                      callback.call(me, res.data);
                  }
                  if (me.f_afterload && typeof me.f_afterload === 'function') {
                      me.f_afterload.call(me, res.data);
                  }
              } else {
                  me.$router.push({
                      name: "Error",
                      params: { message: res.message }
                  });
              }
          });
      } else if (me.initData) {
          me.form = me.initData;
      }
    },
    f_afterload() {
      var me = this,
        id = id || me.initId || me.$route.params.id || me.$route.query.id;
      if (id) {
          me.$loading({
              url: me.mainDataUrl + id,
          }).then(function (res) {
              if (res.success) {
                  me.mainData = res.data
              } else {
                  me.$router.push({
                      name: "Error",
                      params: res
                  });
              }
          });
      }
    },
    requestListData(num) {
      if(num == 'main') return
      var me = this,
        id = id || me.initId || me.$route.params.id || me.$route.query.id,
        url = ""
      if(num == 8) {
        url = me.radio_8 ? me.urlList[num][0] : me.urlList[num][1]
      }
      else if(num == 9) {
        url = me.radio_9 ? me.urlList[num][0] : me.urlList[num][1]
      }
      else {
        url = me.urlList[num]
      }
      if (id) {
        me.$loading({
            url: url + id,
        }).then(function (res) {
            if (res.success) {
                me.listData = res.data
            } else if (res.children) {
                me.listData = me.flatten(res.children)
            } else {
                me.$weui.topTips(res.message, "3000");
            }
        });
      }
    },
    getItemType(num, type) {
      return this.itemType[num][type] || type
    },
    flatten(data) {
      let me = this
      let arr = []
      data.map(item => {
        arr.push(item)
        if(item.children) {
          arr = arr.concat(me.flatten(item.children))
        }
      })
      return arr
    }
  },
  watch: {
    selected() {
      this.requestListData(this.selected)
    },
    radio_8() {
      this.requestListData(8)
    },
    radio_9() {
      this.requestListData(9)
    }
  },
}
</script>

<style scoped>
.selector {
  margin: 20px 30px;
  display: flex;
  color: var(--weui-FG-0);
  justify-content:space-between;
}
</style>